import { Grid } from "@mui/material";
import React, { useState } from "react";
import MenuLayout from "../app/MenuLayout";
import { useTranslation } from "react-i18next";
import { canMaintainReceipts, canReadReceipts } from "../../store/actions/LoginActions";
import UnauthorizedPage from "../app/UnauthorizePage";
import ReceiptSearch, { ReceiptSearchCondition } from "./ReceiptSearch";
import ReceiptTable from "./ReceiptTable";

const ReceiptOverview: React.FC = () => {
  const { t } = useTranslation();
  const [receiptSearchCondition, setReceiptSearchCondition] = useState<ReceiptSearchCondition>({});

  if (!canReadReceipts() && !canMaintainReceipts()) {
    return <UnauthorizedPage />;
  }

  return (
    <MenuLayout headline={t("receiptOverview.headline")}>
      <Grid item md={12}>
        <ReceiptSearch setSearchCondition={setReceiptSearchCondition} />
      </Grid>
      <ReceiptTable searchCondition={receiptSearchCondition} />
    </MenuLayout>
  );
};

export default ReceiptOverview;
